<template>
  <div
    class="offer offer-display"
    v-if="offer"
    :lang="offer.language || 'de'"
    :data-offer-language="offer.language || 'de'"
  >
    <ScrollSpy />
    <section
      v-if="!editable"
      class="header"
      id="ueberblick"
    ></section>
    <b-container
      fluid
      class="pt-4"
    >
      <b-row>
        <b-col class="mb-3">
          <Heading
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
      </b-row>
      <b-row class="meta-data">
        <b-col
          md="4"
          class="mb-4"
        >
          <CustomerAddress
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
        <b-col
          md="4"
          class="mb-4"
        >
          <SeminarDetails
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
        <b-col
          md="4"
          class="mb-4"
        >
          <ContactPerson
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col
          md="8"
          class="introduction mb-4"
        >
          <Introduction
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
        <b-col
          md="4"
          class="ekomi-col text-center mb-4"
        >
          <Ekomi
            :options="{ editable: false }"
            @dirty="showsave = true"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col class="trust mb-4">
          <TrustElements
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
      </b-row>

      <company-reviews
        v-if="offer.hash !== '6497f85ead'"
        @dirty="showsave = true"
        :editable="editable"
      />
      <seminar-reviews
        v-if="offer.hash !== '6497f85ead'"
        @dirty="showsave = true"
        :editable="editable"
      />

      <b-row class="sales-stats" v-if="!isOpenSeminar">
        <b-col>
          <SalesStats
            :options="{ editable: false }"
            @dirty="showsave = true"
          />
        </b-col>
      </b-row>
      <div class="page-break"></div>
      <b-row id="angebot">
        <b-col
          class="price-table"
          v-if="offer.id >= 6586"
        > <!-- Feature Release on 2023-08-04 -->
          <Offer
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
        <b-col
          class="price-table mb-4"
          v-else
        >
          <PricingTableLegacy
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col class="service mb-4">
          <ServiceList
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
      </b-row>
      <div
        class="page-break"
        v-if="isInhouse"
      ></div>
      <b-row>
        <b-col
          class="service"
          :class="{ 'mb-4': isInhouse }"
        >
          <AdditionalInfo
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
      </b-row>
      <b-row v-if="isInhouse && !isRemoteOnly"><!-- && !offer.isRemote ??? macht das nicht sinn hier beachte fragen -->
        <b-col
          md="12"
          class="equipment"
        >
          <Equipment
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
      </b-row>
      <div class="page-break"></div>
      <b-row
        v-if="seminar"
        id="schulungsinhalte"
      >
        <b-col
          md="12"
          class="mb-4 mt-4"
        >
          <SeminarContent
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
      </b-row>
      <div class="page-break"></div>
      <b-row
        v-if="trainer"
        id="dozent"
      >
        <b-col
          class="trainer-col mb-4"
          :md="trainerRating && trainerRating.length && (editable || offer.showTrainerReviews) != 0 ? '8' : '12'"
        >
          <TrainerProfile
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
        <!-- TrainerReviews -->
        <trainer-reviews
          id="trainerReviews"
          :editable="editable"
          @dirty="showsave = true"
        ></trainer-reviews>

      </b-row>
      <b-row>
        <b-col>
          <ServiceContractNotice :offer-type-id="offer.offerType_id" />
        </b-col>
      </b-row>
      <div class="page-break"></div>
      <b-row id="gfucyrusag">
        <b-col class="about mb-4">
          <AboutGfu
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
      </b-row>
      <b-row id="durchfuehrungsarten">
        <b-col class="execution mb-4">
          <ExecutionTypes
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
      </b-row>
      <div class="page-break"></div>
      <b-row id="services">
        <b-col md="12">
          <ServiceCards
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
      </b-row>
      <b-row class="offer-imprint">
        <b-col cols="12">
          <div class="offer-imprint-line"></div>
        </b-col>
        <b-col
          md="3"
          class="offer-imprint-text"
        >
          <p class="mb-0"><strong>{{ $t('legal.board') }}</strong> Oliver Mostert</p>
          <p class="mb-0"><strong>{{ $t('legal.supervisoryBoard') }}</strong> Miriam Löffler</p>
        </b-col>
        <b-col
          md="3"
          class="offer-imprint-text"
        >
          <p class="mb-0"><strong>Deutsche Bank</strong></p>
          <p class="mb-0">IBAN: DE48 3707 0060 0111 5823 00</p>
          <p class="mb-0">BIC: DEUTDEDK</p>
        </b-col>
        <b-col
          md="3"
          class="offer-imprint-text"
        >
          <p class="mb-0"><strong>Sparkasse KölnBonn</strong></p>
          <p class="mb-0">IBAN: DE84 3705 0198 1933 6083 49</p>
          <p class="mb-0">BIC: COLSDE33</p>
        </b-col>
        <b-col
          md="3"
          class="offer-imprint-text"
        >
          <p class="mb-0">{{ $t('legal.taxNumber') }} 216/5871/0707</p>
          <p class="mb-0">{{ $t('legal.vatId') }} DE122654743</p>
          <p class="mb-0">{{ $t('legal.court') }}</p>
        </b-col>
      </b-row>
    </b-container>
    <div
      v-if="updateable"
      class="editor-save show"
    > <!-- :class="{'show' : showsave}" -->
      <b-card class=" bg-gfu text-light">
        <b-container>
          <b-row>
            <b-col lg="6">
              <h4><i class="material-icons">edit</i> Editiermodus</h4>
            </b-col>
            <b-col lg="6">
              <b-button
                class="btn-cta float-right"
                @click="onSubmit"
                :disabled="!showsave ? true : false"
              ><i class="material-icons">close</i> Speichern & Beenden</b-button>
              <b-button
                class="btn-success float-right mr-2"
                @click="quickSave"
                :disabled="!showsave ? true : false"
              ><i class="material-icons">save</i> Speichern</b-button>

              <b-button
                class="btn btn-light float-right mr-2"
                @click="confirmActionBack"
              ><i class="material-icons">list_alt</i> Zurück</b-button>
            </b-col>
          </b-row>
        </b-container>
      </b-card>
    </div>
  </div>
  <div
    v-else
    class="loading-page"
  >
    <div class="loading-icon"></div>
  </div>
</template>

<script>
import Heading from '../components/editor/Heading';
import CustomerAddress from '../components/editor/CustomerAddress';
import SeminarDetails from '../components/editor/SeminarDetails';
import ContactPerson from '../components/editor/ContactPerson';
import Introduction from '../components/editor/Introduction';
import Ekomi from '../components/editor/Ekomi';
import SalesStats from '../components/editor/SalesStats';
import ServiceList from '../components/editor/ServiceList';
import ServiceContractNotice from '../components/editor/ServiceContractNotice';
import AdditionalInfo from '../components/editor/AdditionalInfo';
import Equipment from '../components/editor/Equipment';
import SeminarContent from '../components/editor/SeminarContent';
import TrainerProfile from '../components/editor/TrainerProfile';
import AboutGfu from '../components/editor/AboutGfu';
import TrustElements from '../components/editor/TrustElements';
import ExecutionTypes from '../components/editor/ExecutionTypes';
import ServiceCards from '../components/editor/ServiceCards';
import CompanyReviews from '../components/editor/CompanyReviews'
import SeminarReviews from '../components/editor/SeminarReviews'
import TrainerReviews from '../components/editor/TrainerReviews';
import ScrollSpy from '../components/editor/ScrollSpy.vue';
import Offer from '../components/editor/Offer.vue';
import PricingTableLegacy from '../components/editor/PricingTableLegacy.vue';

import { mapGetters, mapActions, mapMutations } from 'vuex';
import { setDocumentLanguage } from '../i18n';

export default {
  name: 'OfferEditor',
  components: {
    Heading,
    CustomerAddress,
    SeminarDetails,
    ContactPerson,
    Introduction,
    Ekomi,
    SalesStats,
    ServiceList,
    ServiceContractNotice,
    AdditionalInfo,
    Equipment,
    SeminarContent,
    TrainerProfile,
    AboutGfu,
    TrustElements,
    ExecutionTypes,
    ServiceCards,
    CompanyReviews,
    SeminarReviews,
    TrainerReviews,
    ScrollSpy,
    Offer,
    PricingTableLegacy
  },
  computed: {
    ...mapGetters([
      'offer',
      'company',
      'contact',
      'seminar',
      'trainer',
      'employee',
      'offerType',
      'trainerRating',
      'fetchCompanyRating',
      'fetchSeminarRating',
      'fetchTrainerRating',
    ]),
    isInhouse() {
      return this.offerType && (this.offerType.id === 1);
    },
    isRemoteOnly() {
      return this.offer.isRemote && !this.offer.isClassroom;
    },
    isOpenSeminar() {
      return this.offer && parseInt(this.offer.offerType_id) === 4;
    },
  },
  data() {
    return {
      hasTrainerReviews: false,
      editable: false,
      updateable: false,
      showsave: false,
      showSeminarReviews: 1,
    }
  },
  methods: {
    ...mapActions([
      'fetchOffer',
      'fetchOfferByVcId',
      'updateOffer',
      'addLastViewed',
    ]),
    ...mapMutations([
      'offerSet'
    ]),
    onSubmit() {
      this.updateOffer()
        .then(() => this.$router.push('/admin/offer-list'));
    },
    quickSave() {
      this.updateOffer()
        .then(() => {
          alert('Gespeichert')
          this.showsave = false;
        })
        .catch((err) => alert('Error on save:' + err.getMessage()))
    },
    confirmActionBack() {
      if (this.showsave) {
        this.boxTwo = ''
        this.$bvModal.msgBoxConfirm('Bist du sicher, dass du zurück zur Übersicht möchtest? Deine letzten Änderungen gehen verlohren?!?', {
          title: 'Änderungen Verwerfen?',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Ja, verwerfen!',
          cancelTitle: 'Nein, abbrechen',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(value => value ? this.$router.push('/admin/offer-list') : null)
          .catch(err => {
            // An error occurred
          })
      } else {
        this.$router.push('/admin/offer-list');
      }
    },
    setReviewVisibility(type, value) {
      const field = 'show' + type.charAt(0).toUpperCase() + type.slice(1) + 'Reviews'
      this.offerSet({ [field]: value });
    },
  },
  mounted() {
    const hash = this.$route.params.offerHash;
    switch (this.$route.name) {
      case 'OfferEditor':
        this.fetchOffer(hash);
        this.editable = true;
        this.updateable = true;
        break;
      case 'OfferCreate':
        this.editable = true;
        break;
      case 'OfferView':
        this.fetchOffer(hash)
          .then(() => this.addLastViewed(hash)) //set last viewd only if in view-mode
          .catch(() => this.$router.push("/404/" + this.$route.params.offerHash));
        this.editable = false;
        break;
      case 'OfferCopy':
        this.fetchOfferByVcId(this.$route.params.vcId);
        this.editable = true;
        break;
      default:
        alert('ERROR');
        break;
    }
  },
  watch: {
    offer: {
      immediate: true,
      handler(offer) {
        if (offer) setDocumentLanguage(offer.language || 'de');
      },
    },
  }
}
</script>

<style>
.offer .offer-imprint {
  margin-top: 24px;
  padding-bottom: 12px;
}

.offer .offer-imprint-line {
  height: 2px;
  background-color: #fdc41f;
  margin-bottom: 14px;
}

.offer .offer-imprint-text {
  font-size: 0.85rem;
  line-height: 1.3;
  color: #033878;
  margin-bottom: 8px;
}

.offer .offer-imprint-text strong {
  color: #033878;
  font-weight: 600;
}
</style>
